import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useBilling } from '../billing-context';
import { useTranslation } from 'src/text';
import { LocationBillingRow } from './location-billing-row';

interface LocationBillingListProps {
  billingCycle: 'monthly' | 'yearly';
}

export const LocationBillingList: React.FC<LocationBillingListProps> = ({
  billingCycle,
}) => {
  const { locations, hasLocations } = useBilling();
  const { billingLabels } = useTranslation();

  if (!hasLocations) {
    return <Typography variant="body2">{billingLabels.noLocations}</Typography>;
  }

  return (
    <Stack spacing={1.5}>
      {locations.map(location => (
        <LocationBillingRow
          key={location.key}
          location={location}
          billingCycle={billingCycle}
        />
      ))}
    </Stack>
  );
};
